import React, { Component } from "react";
import { StaticQuery, graphql } from "gatsby";

import { MediaItem } from "../../TrustedMediaList";
class FiatDepositsMadeEasy extends Component {
  render() {
    return (
      <>
        <div id="fiat-deposits-made-easy">
          {this.props.content.edges && (
            <div className="container">
              <div className="row">
                <div className="col-lg-8 offset-lg-2 box">
                  <div
                    className="text-center mb-5"
                    data-sal="slide-up"
                    data-sal-duration="400"
                    data-sal-easing="ease-in-quad"
                  >
                    <h2
                      dangerouslySetInnerHTML={{
                        __html:
                          this.props.content.edges[0].node.acfPartials.pHeading,
                      }}
                    />
                    <div
                      dangerouslySetInnerHTML={{
                        __html:
                          this.props.content.edges[0].node.acfPartials.pContent,
                      }}
                    />
                  </div>
                </div>
              </div>
            </div>
          )}
          <div id="media-links" className="home">
            <div className="container py-5">
              {this.props.partners.edges && (
                <div className="d-flex flex-row flex-wrap flex-lg-nowrap justify-content-center">
                  {this.props.partners?.edges.map(
                    ({ node: { title, acfPartners } }, i) => (
                      <MediaItem
                        key={`medie-item-${i}`}
                        title={title}
                        publicURL={
                          acfPartners.pLogoColoured.localFile.publicURL
                        }
                        data-sal="slide-up"
                        data-sal-duration="400"
                        data-sal-easing="ease-in-quad"
                        data-sal-delay={`${i + 1}00`}
                      />
                    )
                  )}
                </div>
              )}

              {this.props.content.edges && (
                <p
                  className="has-text-align-center mt-5 text-uppercase"
                  data-sal="slide-up"
                  data-sal-duration="400"
                  data-sal-easing="ease-in-quad"
                  data-sal-delay="100"
                >
                  <div
                    className="has-inline-color has-cyan-bluish-gray-color"
                    dangerouslySetInnerHTML={{
                      __html:
                        this.props.content.edges[0].node.acfPartials
                          .pButtonText,
                    }}
                  />
                </p>
              )}
            </div>
          </div>
        </div>
      </>
    );
  }
}

export default (props) => (
  <StaticQuery
    query={graphql`
      query {
        mediaLinks: allWpPartnersItem(
          filter: {
            acfGlobalConfiguration: { gcLinkTo: { eq: ".co.id" } }
            acfPartners: { pLocation: { eq: "home" } }
          }
          sort: { order: DESC, fields: date }
        ) {
          edges {
            node {
              title
              acfPartners {
                pLogoColoured {
                  localFile {
                    publicURL
                  }
                }
              }
            }
          }
        }
      }
    `}
    render={(data) => (
      <FiatDepositsMadeEasy partners={data.mediaLinks} {...props} />
    )}
  />
);
